module.exports = __webpack_public_path__ + "static/media/homestay_japan.bd081978.jpg";